/**
 * Represents the type of a category an `AppSwitcherLink` can fall under.
 *
 * Possible values are:
 * - `OWNED`: Represents a category that is owned by the user.
 * - `OTHER`: Represents a category that is not owned by the user.
 */
export var CategoryType;
(function (CategoryType) {
    CategoryType[CategoryType["OWNED"] = 0] = "OWNED";
    CategoryType[CategoryType["OTHER"] = 1] = "OTHER";
})(CategoryType || (CategoryType = {}));
